import React from 'react';
import { ILiftsStat, IRunsStat } from '@/api/resort/types';
import { openCount } from '@/util/openCount';

/**
 * The "N / total" open-count cell shared by the snow-report tables
 * (lifts open, runs open).
 *
 * A resort that hasn't reported a count sends `open: null`, which is not
 * the same as reporting none open — rendering it as `0` told users a
 * fully-open resort was shut. The unreported half renders as a dash while
 * the total, which is real data, still shows.
 */
export const OpenCount = ({ stat, dash }: {
  stat?: ILiftsStat | IRunsStat;
  /** The locale's dash glyph, from `t('common.dash')`. */
  dash: string;
}) => {
  if (typeof stat?.total !== 'number') return <>{dash}</>;
  return (
    <>
      {openCount(stat) ?? dash}
      {' / '}
      <span className="text-muted-foreground">{stat.total}</span>
    </>
  );
};
